(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-reserve"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('amaris-product-reserve')) {
    customElements.define('amaris-product-reserve', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const variants = JSON.parse(this.querySelector('script').textContent);
        const link = this.querySelector('a');
        const update = () => {
          const section = this.closest('.shopify-section');
          const input = section?.querySelector('form[action*="/cart/add"] [name="id"]');
          const id = input?.value || new URL(location.href).searchParams.get('variant') || this.dataset.defaultVariant;
          const variant = variants.find(item => String(item.id) === String(id));
          if (!variant) return;
          const url = new URL(this.dataset.productUrl, location.origin);
          url.searchParams.set('variant', variant.id);
          const message = [this.dataset.message, this.dataset.productLabel + ': ' + this.dataset.productTitle];
          if (variant.title !== 'Default Title') message.push(this.dataset.variantLabel + ': ' + variant.title);
          if (variant.sku) message.push(this.dataset.skuLabel + ': ' + variant.sku);
          message.push(this.dataset.priceLabel + ': ' + variant.price, url.toString());
          link.href = 'https://wa.me/919971064440?text=' + encodeURIComponent(message.join('\n'));
        };
        link.addEventListener('click', update);
        link.addEventListener('auxclick', update);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
